<h1 mat-dialog-title>{{Localization.PasswordChangedSuccess | translate}}</h1>
<mat-dialog-actions align="end" >
  <button mat-button mat-dialog-close>{{ Localization.Close | translate }}</button>
</mat-dialog-actions>
